module.exports = __webpack_public_path__ + "static/img/performance06.2484b00b.jpg";